import { useMutation } from '@apollo/client'
import { BucketSharePasswordValidateDocument } from '../../../graphql/generated'
import { publicPasswordValidatedVar } from '../../../providers/apollo/cache'
import logger from '../../../utils/logger'

export default function useBucketSharePasswordValidate() {
  const [mutation, results] = useMutation(BucketSharePasswordValidateDocument, {
    onError: (err) => {
      logger.info('Error validating password', err)
    },
    onCompleted: (res) => {
      if (res.bucketSharePasswordValidate) {
        publicPasswordValidatedVar(true)
      } else {
        publicPasswordValidatedVar(false)
      }
    }
  })

  const isPasswordValid = results.data?.bucketSharePasswordValidate ?? false

  return { mutation, isPasswordValid }
}
